export default "__VITE_ASSET__D$eCePKm__"